import { UploadTypeEnum, UploadStatusEnum, OCRModeEnum } from '@/shared/tools/ocr/enum';
import type { OCRBothInfo } from '@/shared/tools/ocr/types';

/** 不同模式结果状态类型 */
interface ModeStatusOptionsType {
  uploadType: UploadTypeEnum,
  result: OCRBothInfo,
  successCount: number,
  base64SrcFirst?: string,
  base64SrcSecond?: string,
}

/** 获取双面识别结果状态 */
export const getBothModeStatus = (options: ModeStatusOptionsType): UploadStatusEnum => {
  const {
    base64SrcFirst, base64SrcSecond, uploadType, result, successCount,
  } = options;

  /** both模式，仅选择一张 */
  const isSingleSource = !(base64SrcFirst && base64SrcSecond)
    && (base64SrcFirst || base64SrcSecond);

  if (isSingleSource) {
    // 相册上传，单张成功则成功，单张失败则API失败
    if (uploadType === UploadTypeEnum.Album) {
      return successCount === 1 ? UploadStatusEnum.SUCCESS : UploadStatusEnum.API_FAIL_UNKNOW;
    }

    // 拍摄上传，单张成功则另外一张超时，单张失败则双面超时
    if (successCount === 1) {
      return result.userName ? UploadStatusEnum.TIMEOUT_BACK : UploadStatusEnum.TIMEOUT_FRONT;
    }

    return UploadStatusEnum.TIMEOUT_BOTH;
  }

  /** both模式，选择两张 */
  // 两张都成功
  if (successCount === 2) {
    return UploadStatusEnum.SUCCESS;
  }

  // 仅成功一张
  if (successCount === 1) {
    return result.userName ? UploadStatusEnum.API_FAIL_BACK : UploadStatusEnum.API_FAIL_FRONT;
  }

  // 双面失败
  return UploadStatusEnum.API_FAIL_BOTH;
};

/** 获取人像面识别结果状态 */
export const getFrontModeStatus = (options: ModeStatusOptionsType): UploadStatusEnum => {
  const { result } = options;

  // 人像面成功
  if (result.userName) {
    return UploadStatusEnum.SUCCESS;
  }

  // 人像与国徽不匹配
  if (result.issues) {
    return UploadStatusEnum.NOT_MATCH;
  }

  // 人像面失败
  return UploadStatusEnum.API_FAIL_FRONT;
};

/** 获取国徽面识别结果状态 */
export const getBackModeStatus = (options: ModeStatusOptionsType): UploadStatusEnum => {
  const { result } = options;

  // 国徽面成功
  if (result.issues) {
    return UploadStatusEnum.SUCCESS;
  }

  // 人像与国徽不匹配
  if (result.userName) {
    return UploadStatusEnum.NOT_MATCH;
  }

  // 国徽面失败
  return UploadStatusEnum.API_FAIL_BACK;
};

/** 识别模式状态方法映射表 */
export const MODE_STATUS_METHODS_MAP = {
  [OCRModeEnum.BOTH]: getBothModeStatus,
  [OCRModeEnum.FRONT]: getFrontModeStatus,
  [OCRModeEnum.BACK]: getBackModeStatus,
};
